import React, { useState, useEffect } from 'react';
import { Form, Select, Card, Tag, Spin, Alert } from 'antd';
import axios from 'axios';

const { Option } = Select;

const NutritionOrderForm = ({ form }) => {
  const [baseDiets, setBaseDiets] = useState([]);
  const [modifications, setModifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedBaseDiet, setSelectedBaseDiet] = useState(null);

  useEffect(() => {
    const fetchOrderSets = async () => {
      try {
        setLoading(true);
        const [baseRes, modRes] = await Promise.all([
          axios.get('/ordersets?type=Base'),
          axios.get('/ordersets?type=Modification'),
        ]);
        setBaseDiets(baseRes.data);
        setModifications(modRes.data);
        setError(null);
      } catch (err) {
        setError('Failed to load nutrition order sets. Please try again.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchOrderSets();
  }, []);

  const handleBaseDietChange = (value) => {
    const diet = baseDiets.find(d => d._id === value);
    setSelectedBaseDiet(diet);
  };

  if (loading) {
    return <Spin tip="Loading Nutrition Plans..." />;
  }

  if (error) {
    return <Alert message={error} type="error" />;
  }

  return (
    <Form form={form} layout="vertical">
      <Form.Item
        name="baseDiet"
        label="Base Diet"
        rules={[{ required: true, message: 'Please select a base diet' }]}
      >
        <Select placeholder="Select a base diet" onChange={handleBaseDietChange}>
          {baseDiets.map(diet => (
            <Option key={diet._id} value={diet._id}>{diet.name}</Option>
          ))}
        </Select>
      </Form.Item>

      {selectedBaseDiet && (
        <Card size="small" title="Base Diet Details" style={{ marginBottom: 16 }}>
          <p>{selectedBaseDiet.description}</p>
          {selectedBaseDiet.keyCharacteristics.map((char, index) => (
            <Tag key={index} color="blue" style={{ marginBottom: 4 }}>{char}</Tag>
          ))}
        </Card>
      )}

      <Form.Item name="modifications" label="Dietary Modifications">
        <Select mode="multiple" placeholder="Select modifications">
          {modifications.map(mod => (
            <Option key={mod._id} value={mod._id}>{mod.name} ({mod.category})</Option>
          ))}
        </Select>
      </Form.Item>
    </Form>
  );
};

export default NutritionOrderForm;
